var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJournalActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4687_5057)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.71854 19.1112C1.90236 20.7568 3.21783 22.0716 4.86271 22.2619C6.72137 22.4769 8.64197 22.6889 10.607 22.6889C12.5721 22.6889 14.4927 22.4769 16.3514 22.2619C17.9962 22.0716 19.3118 20.7568 19.4955 19.1112C19.7021 17.2613 19.9017 15.35 19.9017 13.3944C19.9017 11.4389 19.7021 9.52758 19.4955 7.67773C19.3118 6.03212 17.9962 4.71728 16.3514 4.52701C14.4927 4.31201 12.5721 4.09991 10.607 4.09991C8.64197 4.09991 6.72137 4.31201 4.86271 4.52701C3.21783 4.71728 1.90236 6.03212 1.71854 7.67773C1.5119 9.52758 1.3125 11.4389 1.3125 13.3944C1.3125 15.35 1.5119 17.2613 1.71854 19.1112Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.2399 4.13171C7.74967 4.19883 6.28798 4.36199 4.86273 4.52686C3.21783 4.71713 1.90236 6.03197 1.71854 7.67758C1.5119 9.52743 1.3125 11.4388 1.3125 13.3943C1.3125 15.3498 1.5119 17.2612 1.71854 19.111C1.90236 20.7566 3.21783 22.0714 4.86271 22.2617C6.72137 22.4767 8.64197 22.6889 10.607 22.6889C12.5721 22.6889 14.4927 22.4767 16.3514 22.2617C17.9962 22.0714 19.3118 20.7568 19.4955 19.111C19.6442 17.7804 19.789 16.4179 19.8586 15.03",
    stroke: "#18202F",
    strokeWidth: 1.71429,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.3296 2.23312L11.0126 9.40083L10.1472 13.4711C10.0079 14.126 10.6906 14.7457 11.3299 14.5447L15.3805 13.2713L21.9052 6.40578C22.9889 5.26549 22.7998 3.35828 21.4881 2.19803C20.207 1.06496 18.3453 1.08067 17.3296 2.23312Z",
    fill: "#B6C0F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.3296 2.23312L11.0126 9.40083L10.1472 13.4711C10.0079 14.126 10.6906 14.7457 11.3299 14.5447L15.3805 13.2713L21.9052 6.40578C22.9889 5.26549 22.7998 3.35828 21.4881 2.19803C20.207 1.06496 18.3453 1.08067 17.3296 2.23312Z",
    stroke: "#18202F",
    strokeWidth: 1.71429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4687_5057"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJournalActive);
export default __webpack_public_path__ + "static/media/journalActive.6622f8e31c832c491ed5a47d69f6f983.svg";
export { ForwardRef as ReactComponent };